module.exports = __webpack_public_path__ + "static/media/room-2.17502aec.jpg";